import { render } from "./FlashMessages.vue?vue&type=template&id=2c3113fc"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__